import { RootState } from "app/store";

export const selectLoadState = (state: RootState) => state.login.apps.loadState;
